// Example presets with images, prompts and results
export interface TryOnExamplePreset {
    id: number;
    name: string;
    clothPreview: string;
    fashionModelPreview?: string;
    prompt: string;
    results: string[];
}

export const tryonExamplePresets: TryOnExamplePreset[] = [
    {
        id: 1,
        name: 'Pink Top',
        clothPreview: "https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/default_user/03703066-03db-4e91-85a9-bd3a4d683830.png/f0b2328b-4e8e-49e2-b0f1-91603da7ea77",
        fashionModelPreview: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80",
        prompt: 'woman wearing pink top full body view',
        results: [
            "https://v3.fal.media/files/kangaroo/IbFypGHWD6QO3ek2FKF9Y.jpeg"
        ]
    },
    {
        id: 2,
        name: 'Long Dress',
        clothPreview: "https://storage.googleapis.com/xdesign-d72cd.appspot.com/uploaded_image/default_user/a651e4c7-63ba-4d43-85ce-257908ce41d4.png/9297d1c0-c83e-49a6-876e-d95cfcc7c663",
        prompt: "woman wearing dress in professional photoshoot in studio",
        results: [
            "https://v3.fal.media/files/koala/wnB5_yMDo5Lz1vxVI9Q2J.jpeg",
            "https://v3.fal.media/files/rabbit/sC607yBB82d6195XqOgmr.jpeg"
        ]
    },
    {
        id: 3,
        name: 'Dress in Park',
        clothPreview: 'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ftryon%2Fsample-cloth-4.jpg?alt=media&token=b8203e15-0863-4208-bf66-8185ebbb2b45',
        prompt: 'woman wearing dress in park',
        results: [
            'https://firebasestorage.googleapis.com/v0/b/xdesign-d72cd.appspot.com/o/example_presets%2Ftryon%2Fsample-tryon-4.png?alt=media&token=35a5bf6a-5dce-4586-bc44-d43456fc0111'
        ]
    }
];

export type ExamplePreset = TryOnExamplePreset;

